import {Component, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {VerticalMenuComponent} from '@core/src/public-api';

@Component({
  selector: 'si-vertical-menu-ext',
  templateUrl: './vertical-menu-ext.component.html',
  styleUrls: ['./vertical-menu-ext.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerticalMenuExtComponent extends VerticalMenuComponent {

  constructor(
    router: Router,
  ) {
    super(router);
  }
}
